import React from 'react'
import ReactDOM from 'react-dom'
import { debounce } from 'lodash'
import { __, sprintf } from 'StylistParent/i18n'
import Dashicon from 'Components/dashicon'

/* Import CSS */
import './index.scss'

class ResponsiveValueNotice extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			isEnabled: false,
			isOver: false,
		}

		// this.handleHoverOn = this.handleHoverOn.bind(this);
	}

	isEnabled = () => {
		// return this.state.isEnabled
	}

	togglePopup = () => {
		this.setState( {
			isOver: ! this.state.isOver,
		} )
	}

	/* toggleResponsiveEditing = () => {
		this.props.toggleResponsiveEditing
	} */
	componentDidMount = () => {
	}

	componentWillMount = () => {
	}

	render() {
		// const { type, name } = this.props;

		const media = '1024px'
		return (
			<div className="stlst-control--responsive-indicator"
				onMouseEnter={ ()=>{ this.togglePopup() } }
				onMouseLeave={ ()=>{ this.togglePopup() } }
			>
				<Dashicon
					icon="info-outline"
				/>
				{ this.state.isOver && <div className="stlst-control--responsive-indicator-message">
					{ /*__( 'The next media query overrides this value:' ) */ }
					{ __( 'Some media queries override this value:' ) }
					<button
						type="button"
						onClick={ this.props.onResponsiveModeToggle }
					>
						{ /* sprintf( __( 'Min-width: %s' ), media ) */ }
						{ __( 'Open Responsive Editing' ) }
					</button>
				</div> }
			</div>
		)
	}
}

export default ResponsiveValueNotice;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/responsive-value-notice/index.jsx